module.exports = __webpack_public_path__ + "static/media/1. Setup demo Helpdesk channels.ae9be03c.svg";